// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1J1pz","messages":"Chat_messages__1AwCu","dateDivider":"Chat_dateDivider__gYpAK"};